import { render, staticRenderFns } from "./Non-job.vue?vue&type=template&id=452b8520&scoped=true&"
import script from "./Non-job.vue?vue&type=script&lang=js&"
export * from "./Non-job.vue?vue&type=script&lang=js&"
import style0 from "./Non-job.vue?vue&type=style&index=0&id=452b8520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452b8520",
  null
  
)

export default component.exports